import SectionHeading from '@/components/feature/SectionHeading';
import FaqAccordion from '@/components/feature/FaqAccordion';
import JsonLd from '@/components/feature/JsonLd';
import { faqs } from '@/mocks/site';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
};

export default function FaqSection() {
  return (
    <section id="faq" className="w-full scroll-mt-24 border-b border-background-200 bg-background-50 py-14 md:py-20">
      <JsonLd data={faqSchema} />
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="FAQ"
              title="关于追剧顺序的常见问题"
              desc="更新节奏、分集介绍口径、预告时间……先在这里找到答案。还有疑问可以在关于我们页面联系我们。"
            />
            <div className="mt-8 rounded-lg border border-dashed border-primary-300 bg-primary-50/60 p-5">
              <p className="flex items-center gap-2 text-sm text-primary-700">
                <i className="ri-lightbulb-line" aria-hidden="true" />
                小提示
              </p>
              <p className="mt-2 text-xs leading-6 text-foreground-600">
                想找某一集的具体剧情，直接在剧集详情页搜索集号，会比从头翻更快。
              </p>
            </div>
          </div>
          <div className="lg:col-span-8">
            <FaqAccordion items={faqs} />
          </div>
        </div>
      </div>
    </section>
  );
}